import { ENDPOINTS, requestType } from "../constants/Variables";
import Api from "./index";

const createAttribute = (_, params) => {
    return Api(ENDPOINTS.ATTRIBUTE.CREATE, params, requestType.POST);
};
const updateAttribute = (id, params) => {
    return Api(ENDPOINTS.ATTRIBUTE.UPDATE.replace(":id", id), params, requestType.PUT);
};

const getAllAttributes = (params) => {

    const url = ENDPOINTS.ATTRIBUTE.GET_ALL_ATTRIBUTES;
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append("search", params.search);

    const finalUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;

    return Api(finalUrl, null, requestType.GET);
};

const getAllAttributesWithValues = (params) => {

    const url = ENDPOINTS.ATTRIBUTE.GET_ALL_ATTRIBUTES_WITH_VALUES;
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append("search", params.search);

    const finalUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;

    return Api(finalUrl, null, requestType.GET);
};

const getSingleAttribute = (id) => {
    return Api(ENDPOINTS.ATTRIBUTE.SINGLE.replace(":id", id), null, requestType.GET);
};

const addAttributeValue = (id, params) => {
    return Api(ENDPOINTS.ATTRIBUTE.ADD_VALUE.replace(":id", id), params, requestType.POST);
};

const removeAttributeValue = (id, valueId) => {
    return Api(ENDPOINTS.ATTRIBUTE.REMOVE_VALUE.replace(":id", id).replace(":valueId", valueId), null, requestType.DELETE);
};

const deleteAttribute = (id) => {
    return Api(ENDPOINTS.ATTRIBUTE.DELETE.replace(":id", id), null, requestType.DELETE);
};

export {
    createAttribute,
    updateAttribute,
    getAllAttributes,
    getSingleAttribute,
    addAttributeValue,
    removeAttributeValue,
    getAllAttributesWithValues,
    deleteAttribute,
};

